import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  Text,
} from '@gousto-internal/citrus-react'

type DietaryWarningTagVariant = 'default' | 'stacked'

type DietaryWarningTagProps = {
  text: string
  variant?: DietaryWarningTagVariant
}

const stylesByVariant: Record<
  DietaryWarningTagVariant,
  { tag: React.CSSProperties; icon: React.CSSProperties; text?: { fontWeight?: FontWeight } }
> = {
  default: {
    tag: {
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
    },
    icon: {
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
    },
  },
  stacked: {
    tag: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: '4px',
      borderTopLeftRadius: 0,
      borderTopRightRadius: '4px',
      opacity: 0.9,
    },
    icon: {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    text: {
      fontWeight: FontWeight.Bold,
    },
  },
}

export function DietaryWarningTag({ text, variant = 'default' }: DietaryWarningTagProps) {
  const variantStyles = stylesByVariant[variant]

  return (
    <Box
      data-testid="dietary-warning-tag"
      bg={Color.ColdGrey_900}
      height="24px"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={1}
      maxWidth="100%"
      minWidth="0"
      style={{
        ...variantStyles.tag,
      }}
      width="fit-content"
    >
      <Box
        data-testid="info-icon"
        style={{
          ...variantStyles.icon,
          flexShrink: 0,
        }}
        bg={Color.Warning_700}
        width="22px"
        paddingH={0.75}
        paddingV={1}
        display={Display.Flex}
      >
        <Icon name="info" style={{ color: Color.White }} size={4} />
      </Box>
      <Box data-testid="dietary-warning-text" minWidth="0" paddingRight={2}>
        <Text
          size={2}
          color={Color.White}
          fontWeight={variantStyles.text?.fontWeight}
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {text}
        </Text>
      </Box>
    </Box>
  )
}
